import type { SVGProps } from 'react';
import React from 'react';

export const ErrorIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 11C0.25 5.06294 5.06294 0.25 11 0.25C16.9371 0.25 21.75 5.06294 21.75 11C21.75 16.9371 16.9371 21.75
        11 21.75C5.06294 21.75 0.25 16.9371 0.25 11ZM11.75 6C11.75 5.58579 11.4142 5.25 11 5.25C10.5858 5.25 10.25
        5.58579 10.25 6V12C10.25 12.4142 10.5858 12.75 11 12.75C11.4142 12.75 11.75 12.4142 11.75 12V6ZM11 14.25C10.3096
        14.25 9.75 14.8096 9.75 15.5C9.75 16.1904 10.3096 16.75 11 16.75C11.6904 16.75 12.25 16.1904 12.25 15.5C12.25 14.8096 11.6904 14.25 11 14.25Z"
      />
    </svg>
  );
};
